import React from 'react';

const SelectField = ({ label, options, value, onChange, disabled, className }) => (
  <div className={`flex flex-col space-y-2 ${className}`}>
    <label className="text-white">{label}</label>
    <select
      className="p-2 rounded-lg bg-gray-800 text-white border-none outline-none"
      value={value}
      onChange={onChange}
      disabled={disabled}
    >
      <option value="" disabled>Select {label}</option>
      {options.map((option, index) => (
        <option key={index} value={option.value || option}>
          {option.label || option}
        </option>
      ))}
    </select>
  </div>
);

export default SelectField;
